"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartMeterHelp = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var copy_1 = require("../../../../../copy");
var MeterHelp_styled_1 = require("./MeterHelp.styled");
var MeterImages_1 = require("./MeterImages");
function getTestID(fuelType, isMultiRate) {
    var prefix = 'smart-meter-help';
    if (isMultiRate) {
        return "".concat(prefix, "_elec-multi");
    }
    return fuelType === 'electricity' ? "".concat(prefix, "_elec-single") : "".concat(prefix, "_gas");
}
function SmartMeterHelp(_a) {
    var fuelType = _a.fuelType, registerCount = _a.registerCount;
    var _b = (0, core_1.useComponents)(), Heading4 = _b.Heading4, Ul = _b.Ul;
    var testId = getTestID(fuelType, registerCount > 1);
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(MeterHelp_styled_1.StyledHelp, null,
        react_1.default.createElement(Heading4, { "data-testid": testId },
            react_1.default.createElement(Copy, { copyKey: "smartMeterHelpHeading" })),
        react_1.default.createElement(MeterHelp_styled_1.StyledHelpLayout, null,
            react_1.default.createElement("div", null, fuelType === 'gas' ? react_1.default.createElement(MeterImages_1.SMETS1GasImage, null) : react_1.default.createElement(MeterImages_1.SMETS1ElecImage, null)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Ul, null, registerCount > 2 ? (react_1.default.createElement(Copy, { copyKey: "smartMeterHelpElecMultiRateCopy" })) : registerCount === 2 ? (react_1.default.createElement(Copy, { copyKey: "smartMeterHelpElecTwinRateCopy" })) : fuelType === 'electricity' ? (react_1.default.createElement(Copy, { copyKey: "smartMeterHelpElecSingleCopy" })) : (react_1.default.createElement(Copy, { copyKey: "smartMeterHelpGasSingleCopy" }))))),
        react_1.default.createElement(Copy, { copyKey: "smartMeterHelpDoesItLookDifferent" })));
}
exports.SmartMeterHelp = SmartMeterHelp;
